export default {
    erppartition(state, payload) { 
        state.erppartition = payload.partition
    },
    partition(state, payload) { 
        state.partition = payload.partition
    },
    language(state, payload) {
        state.language = payload.language
    },
}